module.exports = __webpack_public_path__ + "img/cadu.ce79658a.jpg";